"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isNumber_1 = tslib_1.__importDefault(require("lodash/isNumber"));
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
var isNaN_1 = tslib_1.__importDefault(require("lodash/isNaN"));
var InputPure_1 = require("./InputPure");
var isValidNumber = function (value) { return isNumber_1.default(value) && !isNaN_1.default(value); };
var isNumberOrString = function (value) {
    return isValidNumber(value) || (isString_1.default(value) && value.length);
};
var toValidValue = function (value) { return (isNumberOrString(value) ? value : ""); };
/**
 * @internal
 */
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value) {
            _this.valueChanged(value);
        };
        var value = props.value;
        _this.state = {
            value: toValidValue(value),
        };
        return _this;
    }
    Input.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var validValue = toValidValue(nextProps.value);
        if (this.props.value !== validValue) {
            this.valueChanged(validValue);
        }
    };
    Input.prototype.valueChanged = function (value) {
        if (this.state.value !== value) {
            this.setState({
                value: value,
            });
            this.props.onChange(value);
        }
    };
    Input.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(InputPure_1.InputPure, tslib_1.__assign({}, this.props, { ref: function (ref) {
                _this.inputNodeRef = ref;
            }, onChange: this.onChange, value: this.state.value })));
    };
    Input.defaultProps = tslib_1.__assign({}, InputPure_1.InputPure.defaultProps);
    return Input;
}(react_1.default.PureComponent));
exports.Input = Input;
//# sourceMappingURL=Input.js.map